var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disqus"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row-md justify-center"},[_c('div',{staticClass:"col-md-8"},[(_vm.pageConfig)?_c('disqus',{attrs:{"shortname":"asphalte-dev","page-config":_vm.pageConfig,"lang":_vm.$i18n.locale.substring(0, 2),"lazy":""}}):_vm._e()],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }